/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_Msg_MuratInputs */

const tr_landing_community_mock_msg_murat = /** @type {(inputs: Landing_Community_Mock_Msg_MuratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kur kuralında yuvarlamayı kaça ayarlıyorsunuz, 10'a mı 100'e mi?`)
};

const en_landing_community_mock_msg_murat = /** @type {(inputs: Landing_Community_Mock_Msg_MuratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What rounding do you use in your FX rule, 10 or 100?`)
};

const de_landing_community_mock_msg_murat = /** @type {(inputs: Landing_Community_Mock_Msg_MuratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf welchen Wert rundet ihr in der Kursregel, 10 oder 100?`)
};

const ru_landing_community_mock_msg_murat = /** @type {(inputs: Landing_Community_Mock_Msg_MuratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До какого значения вы округляете в курсовом правиле, до 10 или до 100?`)
};

/**
* | output |
* | --- |
* | "What rounding do you use in your FX rule, 10 or 100?" |
*
* @param {Landing_Community_Mock_Msg_MuratInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_msg_murat = /** @type {((inputs?: Landing_Community_Mock_Msg_MuratInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_Msg_MuratInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_msg_murat(inputs)
	if (locale === "de") return de_landing_community_mock_msg_murat(inputs)
	if (locale === "ru") return ru_landing_community_mock_msg_murat(inputs)
	return tr_landing_community_mock_msg_murat(inputs)
});